import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDesignSystem12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconDesignSystem12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#DesignSystem12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M10.394 2.903 9.101 1.61l-.956.955L9.44 3.858zM1.979 8.731l5.46-5.459 1.293 1.294-5.46 5.459-1.658.365zM8.772 5.94l2.33-2.33a1 1 0 0 0 0-1.414L9.807.903a1 1 0 0 0-1.414 0l-2.33 2.33-2.18-2.183a1.5 1.5 0 0 0-2.122 0l-.707.708a1.5 1.5 0 0 0 0 2.12l2.182 2.183-2.17 2.17-.429 1.944a1 1 0 0 0 1.192 1.191l1.944-.427 2.17-2.17 2.182 2.181a1.5 1.5 0 0 0 2.121 0l.708-.707a1.5 1.5 0 0 0 0-2.121zm-.707.707L6.65 8.06l2.182 2.182a.5.5 0 0 0 .707 0l.707-.707a.5.5 0 0 0 0-.707l-.68-.682-.708.707a.5.5 0 1 1-.707-.707l.707-.707zM5.357 3.939l-.792-.792-.707.707a.5.5 0 0 1-.707-.707l.707-.707-.683-.682a.5.5 0 0 0-.707 0l-.707.707a.5.5 0 0 0 0 .707l2.182 2.181z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="DesignSystem12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconDesignSystem12);
